"use strict";Object.defineProperties(exports,{__esModule:{value:!0},[Symbol.toStringTag]:{value:"Module"}});const e=require("./FontAwesomeV6Icon.js"),t=require("./constants/index.js");exports.default=e;exports.kitIcons=t.kitIcons;
//# sourceMappingURL=index.js.map
